import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoDocumentoService {
  private apiUrl =  `${environment.apiUrl}/api/tipodocumento`; 
  //private apiUrl = 'http://localhost:3000/api/tipodocumento';

  constructor(private http: HttpClient) {}

  getTiposDocumento(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, {
      withCredentials: true
    }).pipe(
      catchError(error => {
        console.error('Error al obtener tipos de documento:', error);
        return throwError(() => new Error('Error al obtener tipos de documento'));
      })
    );
  }
}
